import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import onClickOutside from 'react-onclickoutside'
import '../assets/css/components/filter-popout-button.css'
import TytoSelect from '../components/TytoSelect'

/**
 *  A button that expands when clicked to show additional filter options
 *  supplied by the children components.
 */
class FilterPopoutButton extends React.Component {
  static propTypes = {
    /** The text that appears on the button and on the popout */
    title:          PropTypes.string.isRequired,
    /** Icon component that is displayed in-line with the title. Ideally, it is a FontAwesome component. */
    iconComponent:  PropTypes.element.isRequired,
    /** Callback to be run when the cancel button is clicked or the popout is closed via the icon */
    onCancel:       PropTypes.func,
    /** Callback to be run the Apply button is clicked. This is usually some function that modifies the Redux state */
    onApply:        PropTypes.func.isRequired,
    /** Toggles whether or not the input is disabled. Disabled components cannot display the popout */
    disabled:       PropTypes.bool,
    children:       PropTypes.node
  }

  constructor(props) {
    super(props)
    this.state = { isExpanded: false }
  }

  handleExpansionToggle = ()=>{
    if(!this.props.disabled) {
      this.setState({ isExpanded: !this.state.isExpanded })
    }
  }

  handleClickOutside = evt => {
    if(_.isFunction(this.props.onCancel) && this.state.isExpanded) {
      this.props.onCancel()
    }
    this.setState({ isExpanded: false })
  }

  handleCancel = ()=> {
    if(_.isFunction(this.props.onCancel)) {
      this.props.onCancel()
    }
    this.setState({ isExpanded: false })
  }

  handleApply = ()=> {
    this.props.onApply()
    this.handleExpansionToggle()
  }

  getButtonClasses = ()=> {
    const base = 'content-filter-button'
    const backgroundClass = this.props.backgroundWhite ? 'white' : null
    const disabledClass = this.props.disabled ? 'disabled' : null

    return [base, backgroundClass, disabledClass].join(' ')
  }

  render() {
    return(
      <div className='filter-popout-wrapper'>
        <div title={this.props.disabled ? 'disabled' : ''} className={this.getButtonClasses()} onClick={this.handleExpansionToggle}>
          <span className='text'>
            {this.props.title}{this.props.iconComponent}
          </span>
        </div>
        {this.state.isExpanded &&
          <div className='popout'>
            <div className='filter-header'>
              <h4>{this.props.title}</h4>
              {React.cloneElement(this.props.iconComponent, { onClick: this.handleCancel })}
            </div>
            <div className='filter-body'>
              {this.props.children}

              <div className='btn-group'>
                <button type='button' onClick={this.handleCancel} className='cancel'>Cancel</button>
                <button type='button' onClick={this.handleApply} className='apply'>Apply Filter(s)</button>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

export default onClickOutside(FilterPopoutButton)
